import { useContext } from "react";
import { ViewportContext, type ViewportContextValue } from "./context";

/**
 * Access viewport controls for the map.
 * Must be used within Map.Canvas.
 *
 * @example
 * const { flyTo, fitBounds, isReady } = useViewport();
 * flyTo([lng, lat], zoom);
 */
export function useViewport(): ViewportContextValue {
  const context = useContext(ViewportContext);
  if (!context) {
    throw new Error("useViewport must be used within Map.Canvas");
  }
  return context;
}
